import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';

export interface IConfirmModal {
	handleOperation: any;
	isOpen: boolean;
	text: string;
	handleClose: any;
	title?: string;
	variant: 'outlined' | 'contained';
	actionButtonText?: string;
}

export default function ConfirmModal(props: IConfirmModal) {
	const { t } = useTranslation();

	return (
		<Dialog maxWidth={'md'} open={props.isOpen} onClose={props.handleClose}>
			<DialogTitle id='responsive-dialog-title'>{props.title ?? t('common.warning')}</DialogTitle>
			<DialogContent>{props.text}</DialogContent>
			<DialogActions>
				<Button onClick={props.handleClose} color='primary'>
					{t('common.cancel')}
				</Button>
				<Button color='primary'variant={props.variant} onClick={props.handleOperation}>
					{props.actionButtonText ?? t('common.save')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
